import './list-control.scss';

import ListControl from './ListControl';

export default ListControl;
